import { createSelector } from '@reduxjs/toolkit';

import { selectUser } from '../offerData/user';

export interface IAnalyticUser {
  type: string;
  email?: string;
  cianUserId?: number;
  userId?: number;
}

export const getAnalyticsUser = createSelector([selectUser], (user): IAnalyticUser => {
  if (!user) {
    return {
      type: 'not_authorized',
    };
  }

  return {
    type: user.ga?.accountType || 'not_authorized',
    email: user.email || undefined,
    cianUserId: user.cianUserId || undefined,
    userId: user.realtyUserId || undefined,
  };
});
